import { render } from "./DaizyDoc.vue?vue&type=template&id=18212522"
import script from "./DaizyDoc.vue?vue&type=script&lang=js"
export * from "./DaizyDoc.vue?vue&type=script&lang=js"

import exportComponent from "E:\\trackzone\\Admin_panel\\admin panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__